import { useEffect, useState } from 'react';
import {
  Wrapper,
  LogoWrapper,
  TextWrapper,
  AppWrapper,
  Image,
} from '@/components/common/footer/Footer.styled';
import { IconVerticalDivider } from '@/components/atoms/Icon';
import { useCommonParams } from '@/hooks';
import { FOOTER_INFO } from '@/const';

interface IFooterInfo {
  logo: string;
  companyName: string;
  ceo: string;
  address: string;
  cs: string;
  companyIntroduction: string;
  privacyPolicy: string;
  companyRegistrationNumber: string;
  copyright: string;
  iosAppDownloadLink: string;
  androidAppDownloadLink: string;
}

const Footer = () => {
  const { media } = useCommonParams();
  const [footerInfo, setFooterInfo] = useState<IFooterInfo>();

  useEffect(() => {
    setFooterInfo(FOOTER_INFO[media.toUpperCase()]);
  }, [media]);

  return (
    <Wrapper>
      <LogoWrapper>
        <Image src={footerInfo?.logo} alt="footer logo" loading="lazy" />
      </LogoWrapper>
      <TextWrapper>
        <div className="company">
          {footerInfo?.companyName} <IconVerticalDivider width={1} height={11} color="gray-400" />{' '}
          {footerInfo?.ceo}
        </div>
        <div className="address">
          {footerInfo?.address} | 사업자등록번호 {footerInfo?.companyRegistrationNumber}
        </div>
        <div className="cs">
          {media !== 'lgu' && (
            <span>
              고객센터: <a href={`mailto:${footerInfo?.cs}`}>{footerInfo?.cs}</a>
              &nbsp;|&nbsp;
            </span>
          )}
          <a href={footerInfo?.companyIntroduction} target="_blank" rel="noreferrer">
            회사소개
          </a>{' '}
          |{' '}
          <a href={footerInfo?.privacyPolicy} target="_blank" rel="noreferrer">
            개인정보처리방침
          </a>
        </div>
        <div className="copy-right">{footerInfo?.copyright}</div>
      </TextWrapper>
      <AppWrapper>
        <a href={footerInfo?.iosAppDownloadLink} target="_blank" rel="noreferrer">
          <Image src="/footer-app-store.svg" alt="app store" loading="lazy" />
        </a>
        <a href={footerInfo?.androidAppDownloadLink} target="_blank" rel="noreferrer">
          <Image src="/footer-google-play.svg" alt="google play" loading="lazy" />
        </a>
      </AppWrapper>
    </Wrapper>
  );
};

export default Footer